import { createContext, useContext, useEffect, useState } from "react";

const AiQualityToolContext = createContext();

const EXPECTED_FIELDS = 17;

const DEFAULT_STATE = {
	expectedFields: 0,
	returnedFields: 0,
	changedFields: 0,
	jobId: null,
};

export const AiQualityToolProvider = ({ children }) => {
	const [qualityCheck, setQualityCheck] = useState(DEFAULT_STATE);

	useEffect(() => {
		console.log("AiQualityToolProvider - qualityCheck", qualityCheck);
	}, [qualityCheck]);

	const resetQualityCheck = () => {
		setQualityCheck(DEFAULT_STATE);
	};

	const setJobId = (jobId) => {
		setQualityCheck((prev) => ({
			...prev,
			jobId,
		}));
	};

	const setResult = ({ returnedFields, changedFields }) => {
		setQualityCheck((prev) => ({
			...prev,
			returnedFields: prev.returnedFields + returnedFields,
			expectedFields: prev.expectedFields + EXPECTED_FIELDS,
			changedFields: prev.changedFields + changedFields,
		}));
	};

	const value = {
		qualityCheck,
		setJobIdToCheck: setJobId,
		setResult,
		resetQualityCheck,
	};

	return (
		<AiQualityToolContext.Provider value={value}>
			{children}
		</AiQualityToolContext.Provider>
	);
};

export const useAiQualityTool = () => useContext(AiQualityToolContext);
